import React from "react";
import ReactDOM from "react-dom/client";
// Before ./App, so logging is initialized before any app module can report to it.
import "./logs";
import App from "./App";
import "maplibre-gl/dist/maplibre-gl.css";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
